import {
  Box,
  Button,
  Paper,
  Tab,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TableSortLabel,
  Tabs,
} from "@mui/material";
import Title from "../../../../components/title";
import { PermissionsPage } from "../../../../util/permissionsPage";
import { useEffect, useRef, useState } from "react";
import { LoadingTable } from "../../../../components/Loading/LoadingTable";
import { NoData } from "../../../../components/NoData/NoData";
import { StyledTableCell } from "../../../franchise/components/StyledTableCell";
import SearchIcon from "@mui/icons-material/Search";

import { useHistory, useParams } from "react-router-dom";
import {
  Search,
  SearchIconWrapper,
  StyledInputBase,
} from "../../../../components/SearchComponent/SearchComponent";
import { debounce } from "throttle-debounce";
import { useUserData } from "../../../../hooks/useUserData";
import { isEmptyObject } from "../../../../util/isEmptyObject";

import ErrorToastHandler from "../../../../util/ErrorToastHandler";
import candidates from "../../../../services/candidates";
import { RowsCandidate } from "../components/RowsCandidate";

const TABS = [
  { label: "Participantes e Aprovados", statuses: ["Participando", "Selecionado"] },
  { label: "Banco de Talentos",          statuses: ["Banco de Talentos"]           },
  { label: "Eliminados",                 statuses: ["Eliminado"]                   },
];

const columnsHeading = [
  { label: "Visualizar",    key: null           },
  { label: "Perfil",        key: "perfil"        },
  { label: "Nome",          key: "nome"         },
  { label: "Telefone",      key: null           },
  { label: "Escolaridade",  key: "escolaridade" },
  { label: "Etapa",         key: "etapa"        },
  { label: "Data Cadastro", key: "dataCadastro" },
  { label: "Endereço",      key: "endereco"     },
  { label: "Excluir",       key: null           },
];

export const SeeCandidates = () => {
  const [isLoadingData, setIsLoadingData] = useState(false);
  const { userData } = useUserData();
  const params = useParams();
  const [total, setTotal] = useState(0);
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(0);
  const [sortKey, setSortKey] = useState(null);
  const [sortDir, setSortDir] = useState("desc");

  const defaultValues = {
    page: 1,
    perPage: 10,
    searchTerm: "",
    orderBy: "id",
    orderByType: "desc",
    idVaga: params.id,
    statuses: TABS[0].statuses,
  };

  const handleBack = () => {
    history.push("/rh/vagas/");
  };

  const [configParams, setConfigParams] = useState(defaultValues);
  const [allData, setAllData] = useState([]);
  const inputRef = useRef(null);

  const handleSort = (key) => {
    if (sortKey === key) {
      const newDir = sortDir === "asc" ? "desc" : "asc";
      setSortDir(newDir);
      setConfigParams((old) => ({ ...old, page: 1, orderBy: key, orderByType: newDir }));
    } else {
      setSortKey(key);
      setSortDir("asc");
      setConfigParams((old) => ({ ...old, page: 1, orderBy: key, orderByType: "asc" }));
    }
  };

  const handleChangePage = (_, newPage) => {
    inputRef.current.value = "";
    setConfigParams((old) => ({ ...old, page: newPage + 1 }));
  };

  const handleSearch = (ev) => {
    setConfigParams((old) => ({ ...old, searchTerm: ev, page: 1 }));
  };

  const handleChangeRowsPerPage = (event) => {
    setConfigParams((old) => ({ ...old, perPage: +event.target.value, page: 1 }));
  };

  const handleTabChange = (_, v) => {
    setActiveTab(v);
    setConfigParams((old) => ({ ...old, page: 1, statuses: TABS[v].statuses }));
  };

  const debounceFunc = debounce(500, handleSearch);

  const getData = async () => {
    setIsLoadingData(true);
    try {
      const response = await candidates.list(params?.id, {
        params: configParams,
      });
      setAllData(response.data.data);
      setTotal(response.data.total);
    } catch (error) {
      new ErrorToastHandler(error).showErrorToast();
    } finally {
      setIsLoadingData(false);
    }
  };

  useEffect(() => {
    if (!isEmptyObject(userData) && !!params?.id) {
      getData();
    }
  }, [configParams, userData, params]);

  return (
    <>
      <>
        <Title title="LISTA DE CANDIDATOS" />
        {PermissionsPage("register_vacancies") && (
          <>
            <Box
              marginY={2}
              mx={2}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  sx={{
                    borderRadius: "4px",
                    borderColor: "#d6d6d6 !important",
                    border: "1px solid",
                  }}
                  disabled={isLoadingData}
                  placeholder="Pesquisar  "
                  inputProps={{
                    ref: inputRef,
                    "aria-label": "search",
                  }}
                  onChange={(e) => debounceFunc(e.target.value)}
                />
              </Search>
              <Button
                variant="outlined"
                onClick={handleBack}
                color="aprincipal"
                type="button"
              >
                Voltar
              </Button>
            </Box>

            <Box mx={2} mb={1}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                textColor="inherit"
              >
                {TABS.map((t, i) => (
                  <Tab key={i} label={t.label} />
                ))}
              </Tabs>
            </Box>

            {isLoadingData ? (
              <LoadingTable />
            ) : (
              <>
                <Box mx={2} sx={{ paddingBottom: "2rem" }}>
                  {allData.length <= 0 ? (
                    <Box
                      width={"100%"}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <NoData />
                    </Box>
                  ) : (
                    <Paper sx={{ width: "100%", overflow: "hidden" }}>
                      <TableContainer>
                        <Table
                          stickyHeader
                          size={"small"}
                          aria-label="collapsible table"
                        >
                          <TableHead>
                            <TableRow>
                              {columnsHeading.map(({ label, key }) => (
                                <StyledTableCell key={label}>
                                  {key ? (
                                    <TableSortLabel
                                      active={sortKey === key}
                                      direction={sortKey === key ? sortDir : "asc"}
                                      onClick={() => handleSort(key)}
                                    >
                                      {label}
                                    </TableSortLabel>
                                  ) : label}
                                </StyledTableCell>
                              ))}
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {allData.map((row) => (
                              <RowsCandidate key={row.id} row={row} onDelete={getData} />
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={total}
                        rowsPerPage={configParams.perPage}
                        page={configParams.page - 1}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage={"Linhas por pagina"}
                        SelectProps={{
                          inputProps: { "aria-label": "rows per page" },
                          native: true,
                        }}
                      />
                    </Paper>
                  )}
                </Box>
              </>
            )}
          </>
        )}
      </>
    </>
  );
};
